import { Component, Inject, Input, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NotificationService } from 'app/shared/services/notification/notification.service';
import { UiService } from 'app/shared/services/ui/ui.service';

export interface DialogData {
  title: string;
  text: string;
  id: string;
  component: string;
  confirm: string;
}

@Component({
  selector: 'app-open-dialog-delete-item',
  templateUrl: './open-dialog-delete-item.component.html',
  styleUrls: ['./open-dialog-delete-item.component.scss']
})
export class OpenDialogDeleteItemComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<OpenDialogDeleteItemComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private uiSrv: UiService,
    private notificationService: NotificationService

  ) { }

  ngOnInit() {
  }

  deleteItem(): void {
    switch (this.data.component) {
      case 'notification':
        this.notificationService.deleteNotification(this.data.id).subscribe({
          next: () => {
            this.dialogRef.close();
            this.uiSrv.showSnackbar(this.data.confirm)
          }
        })
        break;

      default:
        break;
    }
  }

}
